import React from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import { Button, ButtonGroup } from 'react-bootstrap';

const duration = 200;

const defaultStyle = {
  transition: `all ${duration}ms ease-out`,
  transform: 'translateY(0)',
  opacity: 0
};

const transitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1, transform: 'translateY(30%)' }
};

class ReportList extends React.Component {
  state = {
    showShareLink: false
  };

  copyToClipboard = uuid => {
    const textField = document.createElement('textarea');
    textField.innerText = `https://${window.location.host}/reports/${uuid}`;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
  };

  handleClickShareLink = uuid => () => {
    this.copyToClipboard(uuid);
    this.setState({ showShareLink: true });
  };

  render() {
    const { showShareLink } = this.state;
    const { uuid, name, onEdit, onDelete } = this.props;

    return (
      <div className="tvt-my-reports__item">
        <button className="tvt-my-reports__item-name" onClick={onEdit}>
          {name}
        </button>
        <Transition
          in={showShareLink}
          timeout={duration}
          unmountOnExit
          onEntered={() =>
            setTimeout(() => this.setState({ showShareLink: false }), 2000)
          }
        >
          {state => (
            <div
              className="tvt-my-reports__modal-share-link"
              style={{
                ...defaultStyle,
                ...transitionStyles[state]
              }}
            >
              <i className="fa fa-check" aria-hidden="true" /> Link copied to
              clipboard
            </div>
          )}
        </Transition>
        <ButtonGroup>
          <Button onClick={this.handleClickShareLink(uuid)}>
            <i className="fa fa-share-alt" />
          </Button>
          <Button onClick={onEdit}>
            <i className="fa fa-pencil" />
          </Button>
          <Button onClick={onDelete}>
            <i className="fa fa-trash" />
          </Button>
        </ButtonGroup>
      </div>
    );
  }
}

ReportList.propTypes = {
  uuid: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default ReportList;
